module.exports = "https://static.wanderu.com/static/media/kayak-logo-small.9b6e6eab.svg";